module.exports = {
    // baseUrl: '/ui/',
    // publicPath: '/klasea/new/',
    publicPath: '/',
    /*
        devServer: {
            clientLogLevel: 'info'
          }
    */
    devServer: {
        disableHostCheck: true
    }
}